// import React, { useState } from "react";
// import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { gtmPush } from "../utils/gtm";

function Header() {
  // const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigate = useNavigate();

  const handleClickHome = () => {
    gtmPush("header_logo_click", { element: "brand_logo", destination: "/" });
    navigate("/");
  };

  return (
    <header className="bg-white shadow-md fixed w-full top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center" onClick={handleClickHome}>
            <img
              src="/images/srilatha_rakesh_logo_.png"
              alt="Tell Us What You Think Banner"
              className="w-[40px] mt-[10px]  "
            />
            <span className="text-xl font-bold text-gray-900">
              Srilatha Rakesh
            </span>
          </div>

          {/* <nav className="hidden md:flex space-x-8">
            <a
              href="#home"
              className="text-gray-700 hover:text-purple-600 transition-colors"
            >
              Home
            </a>
            <a
              href="#about"
              className="text-gray-700 hover:text-purple-600 transition-colors"
            >
              About
            </a>
            <a
              href="#services"
              className="text-gray-700 hover:text-purple-600 transition-colors"
            >
              Services
            </a>
            <a
              href="#testimonials"
              className="text-gray-700 hover:text-purple-600 transition-colors"
            >
              Testimonials
            </a>
            <a
              href="#resources"
              className="text-gray-700 hover:text-purple-600 transition-colors"
            >
              Resources
            </a>
            <a
              href="#contact"
              className="text-gray-700 hover:text-purple-600 transition-colors"
            >
              Contact
            </a>
          </nav> */}

          {/* <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-purple-600"
            >
              {isMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div> */}
        </div>
      </div>

      {/* {isMenuOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
            <a
              href="#home"
              className="block px-3 py-2 text-gray-700 hover:text-purple-600"
            >
              Home
            </a>
            <a
              href="#about"
              className="block px-3 py-2 text-gray-700 hover:text-purple-600"
            >
              About
            </a>
            <a
              href="#services"
              className="block px-3 py-2 text-gray-700 hover:text-purple-600"
            >
              Services
            </a>
            <a
              href="#testimonials"
              className="block px-3 py-2 text-gray-700 hover:text-purple-600"
            >
              Testimonials
            </a>
            <a
              href="#resources"
              className="block px-3 py-2 text-gray-700 hover:text-purple-600"
            >
              Resources
            </a>
            <a
              href="#contact"
              className="block px-3 py-2 text-gray-700 hover:text-purple-600"
            >
              Contact
            </a>
          </div>
        </div>
      )} */}
    </header>
  );
}

export default Header;
